import React, { useEffect, useRef, useState } from 'react';
import { BUS_EVENTS, eventBus, updateCanvasSize } from '../../../../utils';
import useEventListener from '../../../PageEditor/hooks/useEventListener';

import { styles } from '../styles';

const Resizeable = ({ onClose, children }) => {
  const classes = styles();

  const [drag, setDrag] = useState({
    active: false,
    y: '',
  });

  const [dims, setDims] = useState({
    h: 275,
  });

  const boxStyle = {
    height: `${dims.h}px`,
    overflow: 'auto',
  };

  const startResize = (e) => {
    setDrag({
      active: true,
      y: e.clientY,
    });
  };

  const resizeFrame = (e) => {
    const { active, y } = drag;
    if (active) {
      const yDiff = Math.abs(y - e.clientY);
      const newH = y > e.clientY ? dims.h + yDiff : dims.h - yDiff;

      if (newH > 400 || newH < 100) return;

      setDrag({ ...drag, x: e.clientX, y: e.clientY });
      setDims({ h: newH });
    }
  };

  const stopResize = () => {
    setDrag({ ...drag, active: false });
  };

  const handleClose = () => {
    const obj = window.canvas.getActiveObject();
    eventBus.emit(BUS_EVENTS.TOGGLE_CHART_SETTINGS, obj);
    onClose();
  };

  const ref = useRef();

  const onWheel = (e) => {
    const { deltaY, deltaX } = e;
    ref.current.scrollTop += deltaY;
    ref.current.scrollLeft += deltaX;
    e.preventDefault();
    e.stopPropagation();
  };

  useEventListener('mouseup', stopResize, window);
  useEventListener('mousemove', resizeFrame, window, [drag.active]);
  useEventListener('wheel', onWheel, ref.current);

  useEffect(() => {
    if (!drag.active) updateCanvasSize(window.canvas, dims.h);
    return () => {
      if (!drag.active) updateCanvasSize(window.canvas, 0, 0);
    };
  }, [drag.active]);

  useEffect(() => {
    updateCanvasSize(window.canvas, dims.h);
  }, []);

  return (
    <>
      <div className={classes.toolBar}>
        <h3>Edit Chart Data</h3>
        <span className={classes.resizeButton} onMouseDown={startResize}>
          ...
        </span>
        <span className={classes.closeButton} onClick={handleClose}>
          ×
        </span>
      </div>
      <div style={boxStyle} onMouseUp={stopResize} ref={ref}>
        {children}
      </div>
    </>
  );
};

export default Resizeable;
